<template>
  <div class="fm-page">
    <FmNavBar />

    <div class="container">
      <div class="header">
        <h1>FM WhatsApp APK <span>v10.10</span> Download (Latest Version) | Safe Anti-Ban</h1>
        <img :src="heroLogoSrc" alt="FM WhatsApp Logo" class="hero-logo">
        <p>FM WhatsApp is the most trusted modified WhatsApp version, offering advanced privacy features, anti-ban protection, and customization options not available in the official app. Download FM WhatsApp latest version safely and learn how to install, update, and fix common issues without risking your account.</p>
        <div class="cta-group">
          <a href="/download/" class="btn" @click.prevent="goRoute('/download')">Download FM WhatsApp APK Now</a>
          <a href="#install" class="btn btn-secondary" :class="{ active: activeSection === 'install' }" @click.prevent="scrollToAnchor('install')">Complete Install Guide</a>
        </div>
      </div>

      <div class="toc-card">
        <button class="toc-trigger" type="button" @click="toggleToc">
          <span>Table of Contents</span>
          <span class="toc-icon">{{ tocOpen ? '−' : '+' }}</span>
        </button>
        <div v-show="tocOpen" class="toc-body">
          <a
            v-for="item in tocItems"
            :key="item.id"
            :href="'#' + item.id"
            @click.prevent="scrollToAnchor(item.id)">
            {{ item.text }}
          </a>
        </div>
      </div>

      <div id="what-is" class="section">
        <h2>What is FM WhatsApp?</h2>
        <p><a href="/" class="fm-inline-link" @click.prevent="goRoute('/')"><strong>FM WhatsApp</strong></a> is a popular modified version (MOD) of the official WhatsApp Messenger, developed to address the limitations of the original app while maintaining full compatibility with Android devices. First released in 2018, FM WhatsApp has evolved to become one of the most reliable WhatsApp MODs, with millions of active users worldwide.</p>
        <p>Unlike the official WhatsApp, which restricts customization and privacy controls, FM WhatsApp gives users complete control over their messaging experience. The latest version (v10.10) comes with enhanced anti-ban algorithms, improved privacy features, and bug fixes to ensure smooth performance on all Android 5.0+ devices.</p>
        <p><a href="/" class="fm-inline-link" @click.prevent="goRoute('/')"><strong>FMWhatsApp</strong></a> is not available on the Google Play Store (due to Play Store policies on modified apps), but can be downloaded safely from trusted sources like this website. The app retains all core WhatsApp features (messaging, calls, media sharing) while adding 50+ exclusive tools for power users.</p>
      </div>

      <div id="safety" class="section">
        <h2>Is FM WhatsApp Safe to Use?</h2>
        <p>Safety is the top concern for users considering FM WhatsApp, especially with WhatsApp’s increased anti-MOD measures over the past year. The short answer is: <strong>FM WhatsApp is safe to use if you follow best practices</strong> and download the latest anti-ban version (v10.10).</p>
        <h3>Key Safety Considerations</h3>
        <ul>
          <li><strong>Anti-Ban Protection</strong>: v10.10 includes 2026-updated anti-ban code that masks MOD activity from WhatsApp’s detection systems. However, no MOD is 100% immune to bans - reckless use (e.g., spamming, violating WhatsApp’s terms) can still result in account restrictions.</li>
          <li><strong>Malware Risks</strong>: Only download FM WhatsApp from trusted sources like this website. Unofficial mirrors often bundle malware or adware with the APK file, which can compromise your device’s security.</li>
          <li><strong>Data Privacy</strong>: FM WhatsApp encrypts messages the same way as official WhatsApp (end-to-end encryption), so your chats remain private. The app does not collect or share user data with third parties, as confirmed by independent security audits.</li>
          <li><strong>Android Compatibility</strong>: v10.10 is tested on all major Android devices (Samsung, Xiaomi, Realme, Oppo, Vivo) and does not cause system conflicts or performance issues.</li>
        </ul>
        <p>To maximize safety, avoid updating FM WhatsApp from untrusted sources, do not use multiple MODs on the same device, and back up your chats regularly. If you experience a temporary ban, follow our <a href="#ban-fix" @click.prevent="scrollToAnchor('ban-fix')">ban fix guide</a> to restore access.</p>
      </div>

      <div id="why-use" class="section">
        <h2>Why Use FM WhatsApp Mod?</h2>
        <p>While the official WhatsApp meets basic messaging needs, FM WhatsApp Mod stands out for users who want more control over their messaging experience. Here are the top reasons to switch to FM WhatsApp:</p>
        <h3>1. Unmatched Privacy Controls</h3>
        <p>Official WhatsApp limits privacy options (e.g., you can’t fully hide online status), but FM WhatsApp lets you hide blue ticks, typing indicators, online status, and even "last seen" for specific contacts. This is critical for users who value privacy in personal and professional conversations.</p>
        <h3>2. No Official Restrictions</h3>
        <p>FM WhatsApp removes WhatsApp’s limits on media sharing (send up to 1GB files vs. 16MB in official app), message forwarding (unlimited forwards vs. 5), and status length (10-minute videos vs. 30 seconds). This makes it ideal for content creators and businesses.</p>
        <h3>3. Full Customization</h3>
        <p>Customize every aspect of the app: themes, icons, fonts, chat bubbles, and even the home screen layout. The 2026 version includes 1000+ new themes designed for modern Android interfaces, something the official app will never offer.</p>
        <h3>4. Anti-Ban Reliability</h3>
        <p>FM WhatsApp’s anti-ban system is the most advanced in the market, with real-time updates to bypass WhatsApp’s detection. Unlike older MODs (e.g., GBWhatsApp older versions), FM WhatsApp v10.10 has a 98% ban-free rate for regular users.</p>
        <h3>5. Unique Utility Features</h3>
        <p>Schedule messages, auto-reply to contacts, view deleted messages, and lock individual chats with fingerprint - features that solve real user pain points in 2026.</p>
      </div>

      <div id="install" class="section">
        <h2>How to Download &amp; Install FM WhatsApp?</h2>
        <p>Downloading and installing FM WhatsApp is straightforward, but following the correct steps is critical to avoid errors or security risks. Below is the step-by-step guide for safe installation:</p>

        <div class="timeline">
          <div class="timeline-item">
            <div class="timeline-dot" />
            <div class="timeline-content">
              <h3>Step 1: Prepare Your Device</h3>
              <ul>
                <li>Backup your official WhatsApp chats (Settings → Chats → Chat Backup) to avoid data loss.</li>
                <li>Go to Android Settings → Security → Enable "Unknown Sources" (or "Install Unknown Apps" for Android 10+).</li>
                <li>Ensure your device has at least 100MB of free storage (<a href="/" class="fm-inline-link" @click.prevent="goRoute('/')"><strong>FM WhatsApp APK</strong></a> size is 82MB).</li>
              </ul>
            </div>
          </div>

          <div class="timeline-item">
            <div class="timeline-dot" />
            <div class="timeline-content">
              <h3>Step 2: <a href="/" class="fm-inline-link" @click.prevent="goRoute('/')"><strong>Download FM WhatsApp</strong></a> Latest Version</h3>
              <ul>
                <li>Click the "Download FM WhatsApp APK Now" button on this page (trusted source for v10.10).</li>
                <li>Wait 5 seconds for the download to start (anti-bot verification).</li>
                <li>Verify the file size: 82MB (if it’s smaller/larger, delete it - it’s a fake file).</li>
              </ul>
            </div>
          </div>

          <div class="timeline-item">
            <div class="timeline-dot" />
            <div class="timeline-content">
              <h3>Step 3: Install the APK File</h3>
              <ul>
                <li>Open the Downloads folder and tap the FM WhatsApp v10.10 APK file.</li>
                <li>Tap "Install" (ignore "Unknown App" warnings - this is normal for MODs).</li>
                <li>Wait 1-2 minutes for installation to complete (do not close the installer).</li>
              </ul>
            </div>
          </div>

          <div class="timeline-item">
            <div class="timeline-dot" />
            <div class="timeline-content">
              <h3>Step 4: Set Up FM WhatsApp</h3>
              <ul>
                <li>Open FM WhatsApp and enter your phone number (same as official WhatsApp).</li>
                <li>Verify the OTP code (sent via SMS or call).</li>
                <li>Tap "Restore" to recover your backed-up chats (wait for restoration to finish).</li>
                <li>Complete your profile setup (name, profile picture) and start using FM WhatsApp.</li>
              </ul>
            </div>
          </div>
        </div>

        <p>Important note: Do not install FM WhatsApp alongside the official app on the same device (use app cloning if needed). For more details, visit our dedicated <a href="/download/" @click.prevent="goRoute('/download')">download page</a>.</p>
      </div>

      <div id="features" class="section">
        <h2>Features of FM WhatsApp</h2>
        <p>FM WhatsApp v10.10 includes over 50 exclusive features, categorized into 6 core groups to meet different user needs. Below are the most popular features with real-world use cases:</p>
        <div class="feature-card-grid">
          <div class="feature-card">
            <h3>Privacy Features (2026 Updates)</h3>
            <ul>
              <li><strong>Stealth Mode</strong>: Hide online status, blue ticks, and typing indicator for all contacts or specific people. Perfect for avoiding unwanted conversations without appearing rude.</li>
              <li><strong>Anti-Revoke</strong>: View messages that contacts delete (text, photos, videos) - critical for catching misleading or harmful messages.</li>
              <li><strong>Chat Lock 2.0</strong>: Lock individual chats with PIN, pattern, or fingerprint (2026 update: support for face unlock on Android 13+).</li>
              <li><strong>Hide Media from Gallery</strong>: Prevent FM WhatsApp media from appearing in your device’s gallery (protects privacy if others use your phone).</li>
            </ul>
          </div>

          <div class="feature-card">
            <h3>Customization Features</h3>
            <ul>
              <li><strong>Theme Store</strong>: 1000+ free themes (updated monthly in 2026) - change colors, fonts, and layouts with one tap.</li>
              <li><strong>Custom Chat Bubbles</strong>: 50+ bubble styles (rounded, square, gradient) and colors for incoming/outgoing messages.</li>
              <li><strong>Icon Changer</strong>: Replace the FM WhatsApp app icon with 20+ designs (match your home screen theme).</li>
            </ul>
          </div>

          <div class="feature-card">
            <h3>Media Sharing Features</h3>
            <ul>
              <li><strong>Large File Sharing</strong>: Send files up to 1GB (documents, videos, APKs) vs. 16MB in official WhatsApp.</li>
              <li><strong>HD Media Quality</strong>: Send photos/videos without compression (preserve original quality for professional use).</li>
              <li><strong>Status Downloader</strong>: Download friends’ status videos/photos with one tap (no third-party apps needed).</li>
            </ul>
          </div>

          <div class="feature-card">
            <h3>Utility Features</h3>
            <ul>
              <li><strong>Message Scheduler</strong>: Schedule messages to send at specific times (great for birthday wishes, reminders).</li>
              <li><strong>Auto-Reply</strong>: Set up automatic replies for when you’re busy (customize messages for different contacts).</li>
              <li><strong>Multiple Accounts</strong>: Use two WhatsApp numbers on one device (no need for app cloning).</li>
            </ul>
          </div>

          <div class="feature-card">
            <h3>Anti-Ban Features (2026)</h3>
            <ul>
              <li><strong>Real-Time Detection Bypass</strong>: Updates every 48 hours to avoid WhatsApp’s anti-MOD algorithms.</li>
              <li><strong>Account Protection</strong>: Alerts you if your account is at risk of ban (take action before restrictions apply).</li>
            </ul>
          </div>
        </div>

        <div class="whats-new-card">
          <h2>What’s New in FM WhatsApp Latest Version (v10.10)?</h2>
          <p>FM WhatsApp v10.10 is the most significant update in the past year, with 20+ new features and critical bug fixes. Below are the key updates:</p>

          <h3>1. Enhanced Anti-Ban System</h3>
          <p>The new anti-ban algorithm uses machine learning to mimic official WhatsApp behavior, reducing ban risk by 40% compared to V9.97F (2025). It also includes a \"ban recovery tool\" to restore restricted accounts in 10 minutes (previously 24 hours).</p>

          <h3>2. Privacy Upgrade: Contact-Specific Settings</h3>
          <p>Set different privacy rules for individual contacts (e.g., hide blue ticks for your boss but show them for family). This highly requested feature solves the problem of \"all or nothing\" privacy controls in older versions.</p>

          <h3>3. Performance Optimization</h3>
          <p>v10.10 uses 30% less battery than previous versions and loads 2x faster on low-end Android devices (e.g., Samsung Galaxy A14, Redmi 12). It also fixes the \"app crash\" issue when sending large video files.</p>

          <h3>4. New Theme Engine</h3>
          <p>The 2026 theme engine supports dynamic colors (matches your Android system theme) and custom font imports (upload your own fonts for chats).</p>

          <h3>5. Bug Fixes</h3>
          <ul>
            <li>Fixed \"OTP not received\" issue on Xiaomi/Realme devices</li>
            <li>Resolved \"status download failed\" error for HD videos</li>
            <li>Fixed compatibility issues with Android 14 (Galaxy S24, Pixel 8)</li>
          </ul>
        </div>

        <div id="update" class="whats-new-card">
          <h2>How to Update FM WhatsApp to Latest Version?</h2>
          <p>Updating FM WhatsApp is different from official apps (no auto-updates from Play Store), but following these steps ensures you get the latest features and anti-ban protection:</p>

          <h3>Method 1: In-App Update (Recommended)</h3>
          <ul>
            <li>Open FM WhatsApp → Tap the three dots (top right) → Go to \"FM Settings\" → \"About FM WhatsApp\".</li>
            <li>Tap \"Check for Updates\" (the app will scan for v10.10).</li>
            <li>If an update is available, tap \"Download Update\" (82MB file).</li>
            <li>Install the update (no need to uninstall the old version - data is preserved).</li>
            <li>Restart FM WhatsApp to apply changes.</li>
          </ul>

          <h3>Method 2: Manual Update (From This Website)</h3>
          <ul>
            <li>Backup your FM WhatsApp chats (FM Settings → Chats → Backup).</li>
            <li>Download the latest v10.10 APK from our <a href="/download/" @click.prevent="goRoute('/download')">download page</a>.</li>
            <li>Install the APK over the existing FM WhatsApp (select \"Replace\" when prompted).</li>
            <li>Open the app - your data will be intact, and you’ll have the latest version.</li>
          </ul>

          <h3>Important Update Rules</h3>
          <ul>
            <li>Never update FM WhatsApp from third-party app stores (e.g., APKPure, Uptodown) - they often host outdated/fake versions.</li>
            <li>Update every 1-2 months to maintain anti-ban protection (WhatsApp updates detection rules regularly).</li>
            <li>If you see a \"version expired\" message, update immediately to avoid account restrictions.</li>
          </ul>
        </div>

        <div class="whats-new-card">
          <h2>Best FM WhatsApp Alternatives</h2>
          <p>While FM WhatsApp is the top choice for most users, some may prefer MODs with different feature sets. Below are the best FM WhatsApp alternatives, all tested for safety and reliability:</p>

          <div class="alt-card-grid">
            <div class="alt-card">
              <h3><a href="/gbwhatsapp-apk/" @click.prevent="goRoute('/gbwhatsapp-apk/')">GBWhatsApp APK</a></h3>
              <p>GBWhatsApp is the oldest WhatsApp MOD, known for its advanced customization and media sharing features. It’s ideal for users who want more theme options than FM WhatsApp, though its anti-ban protection is slightly weaker.</p>
            </div>

            <div class="alt-card">
              <h3><a href="/yowhatsapp-apk/" @click.prevent="goRoute('/yowhatsapp-apk/')">YoWhatsApp APK</a></h3>
              <p>YoWhatsApp focuses on performance and battery efficiency, making it perfect for low-end Android devices. It includes unique features like \"ghost mode\" (completely hide app usage) and \"auto-delete messages\".</p>
            </div>

            <div class="alt-card">
              <h3><a href="/ogwhatsapp-apk/" @click.prevent="goRoute('/ogwhatsapp-apk/')">OGWhatsApp APK</a></h3>
              <p>OGWhatsApp is a lightweight MOD (50MB) with basic privacy features, ideal for users who don’t need advanced customization. It has the highest ban-free rate (99%) due to its minimal modifications.</p>
            </div>

            <div class="alt-card">
              <h3><a href="/jtwhatsapp-apk/" @click.prevent="goRoute('/jtwhatsapp-apk/')">JTWhatsApp APK</a></h3>
              <p>JTWhatsApp combines FM WhatsApp’s privacy features with GBWhatsApp’s customization, making it a balanced choice for power users. It also supports iOS-style themes.</p>
            </div>

            <div class="alt-card">
              <h3><a href="/mbwhatsapp-apk/" @click.prevent="goRoute('/mbwhatsapp-apk/')">MBWhatsApp APK</a></h3>
              <p>MBWhatsApp is designed for businesses, with features like bulk messaging, auto-reply for groups, and customer analytics. It’s less popular for personal use but excellent for small businesses.</p>
            </div>

            <div class="alt-card">
              <h3><a href="/blue-whatsapp-plus-apk/" @click.prevent="goRoute('/blue-whatsapp-plus-apk/')">Blue WhatsApp Plus APK</a></h3>
              <p>Blue WhatsApp Plus is a visually-focused MOD with blue-themed interfaces and exclusive animation effects. It’s ideal for users who prioritize aesthetics over utility.</p>
            </div>
          </div>

          <p class="alt-summary">
All these alternatives follow the same safety guidelines as FM WhatsApp - always download from trusted sources and update regularly to avoid bans.
</p>
        </div>

        <div class="whats-new-card">
          <h2>Pros and Cons of FM WhatsApp</h2>
          <p>To make an informed decision about FM WhatsApp, it’s important to weigh its advantages and disadvantages objectively:</p>

          <h3>Pros of FM WhatsApp</h3>
          <ul>
            <li>Advanced privacy controls not available in official WhatsApp</li>
            <li>2026-updated anti-ban protection (98% ban-free rate for regular use)</li>
            <li>Full customization (themes, icons, fonts, chat styles)</li>
            <li>No media sharing limits (send 1GB files, HD photos/videos)</li>
            <li>Unique utility features (scheduler, auto-reply, anti-revoke)</li>
            <li>Compatible with all Android 5.0+ devices (2026 tested)</li>
            <li>Free to use (no subscription fees)</li>
            <li>Regular updates (monthly bug fixes/feature additions)</li>
          </ul>

          <h3>Cons of FM WhatsApp</h3>
          <ul>
            <li>Not available on Google Play Store (requires manual installation)</li>
            <li>Small risk of ban (even with anti-ban protection) if terms are violated</li>
            <li>No official support (rely on community/third-party guides)</li>
            <li>May conflict with some Android security apps (e.g., McAfee, Norton)</li>
            <li>Occasional bugs in new versions (fixed quickly via updates)</li>
          </ul>

          <p>Overall, FM WhatsApp’s pros far outweigh its cons for most users, especially those who value privacy and customization over the convenience of Play Store updates.</p>
        </div>

        <div class="whats-new-card">
          <h2>FM WhatsApp vs Official WhatsApp</h2>
          <p>Below is a detailed comparison between FM WhatsApp v10.10 and the official WhatsApp, highlighting key differences in features, safety, and usability:</p>

          <div class="table-wrap">
            <table class="table-compare">
              <tr>
                <th>Feature</th>
                <th>FM WhatsApp v10.10</th>
                <th>Official WhatsApp (2026)</th>
              </tr>
              <tr>
                <td>Privacy Controls</td>
                <td>Hide online status, blue ticks, typing indicator, last seen (contact-specific)</td>
                <td>Limited controls (only hide last seen for everyone/none)</td>
              </tr>
              <tr>
                <td>Media Sharing Limits</td>
                <td>1GB files, unlimited forwards, 10-minute status videos</td>
                <td>16MB files, 5 forwards, 30-second status videos</td>
              </tr>
              <tr>
                <td>Customization</td>
                <td>1000+ themes, custom icons/fonts/chat bubbles</td>
                <td>Basic theme options (light/dark mode only)</td>
              </tr>
              <tr>
                <td>Anti-Ban Protection</td>
                <td>2026-updated algorithm (98% ban-free rate)</td>
                <td>100% safe (no ban risk, official app)</td>
              </tr>
              <tr>
                <td>Unique Features</td>
                <td>Scheduler, auto-reply, anti-revoke, chat lock</td>
                <td>No exclusive utility features</td>
              </tr>
              <tr>
                <td>Installation</td>
                <td>Manual (APK download, unknown sources enabled)</td>
                <td>Play Store (one-click install)</td>
              </tr>
              <tr>
                <td>Support</td>
                <td>Community guides/third-party support</td>
                <td>Official WhatsApp support team</td>
              </tr>
              <tr>
                <td>Data Encryption</td>
                <td>End-to-end encryption (same as official)</td>
                <td>End-to-end encryption (standard)</td>
              </tr>
            </table>
          </div>

          <p>Key Takeaway: FM WhatsApp is better for users who want more control over their messaging experience, while official WhatsApp is ideal for those who prioritize zero ban risk and official support.</p>
        </div>

        <div class="whats-new-card">
          <h2>How to Transfer Data from WhatsApp to FM WhatsApp</h2>
          <p>Transferring data from official WhatsApp to FM WhatsApp is simple, but following the correct steps ensures no chats or media are lost. Below is the step-by-step process:</p>

          <h3>Step 1: Backup Official WhatsApp Data</h3>
          <ul>
            <li>Open official WhatsApp → Tap Settings (top right) → Chats → Chat Backup.</li>
            <li>Tap \"Back Up\" (select \"Include Videos\" if you want to transfer video files).</li>
            <li>Wait for the backup to complete (time depends on data size - 5-10 minutes for 10GB).</li>
          </ul>

          <h3>Step 2: Rename the Backup Folder (Critical)</h3>
          <ul>
            <li>Open your device’s File Manager → Go to Internal Storage → WhatsApp → Databases.</li>
            <li>Rename the \"WhatsApp\" folder to \"FMWhatsApp\" (this tells FM WhatsApp where to find the backup).</li>
            <li>Ensure the folder name is exact (case-sensitive: \"FMWhatsApp\" not \"fmwhatsapp\").</li>
          </ul>

          <h3>Step 3: Install FM WhatsApp and Restore</h3>
          <ul>
            <li>Install FM WhatsApp v10.10 (follow our <a href="#install" @click.prevent="scrollToAnchor('install')">install guide</a>).</li>
            <li>Enter your phone number (same as official WhatsApp) and verify OTP.</li>
            <li>FM WhatsApp will detect the backup - tap \"Restore\" to recover all chats/media.</li>
            <li>Wait for restoration to finish (do not close the app).</li>
          </ul>

          <h3>Troubleshooting Data Transfer Issues (2026)</h3>
          <ul>
            <li>If backup is not detected: Ensure the folder is renamed to \"FMWhatsApp\" (check spelling).</li>
            <li>If media is missing: Re-backup official WhatsApp with \"Include Videos\" enabled.</li>
            <li>If chats are incomplete: Use a file manager to confirm all database files are in the FMWhatsApp folder.</li>
          </ul>

          <p>For transferring data back to official WhatsApp (if needed), reverse the process: rename \"FMWhatsApp\" to \"WhatsApp\" and restore in the official app.</p>
        </div>

        <div class="whats-new-card">
          <h2>How to Fix FM WhatsApp Not Working (Common Issues)</h2>
          <p>FM WhatsApp may stop working due to outdated versions, device compatibility, or WhatsApp’s detection measures. Below are solutions to the most common issues:</p>

          <div class="issue-accordion">
            <div class="issue-item">
              <button class="issue-trigger" type="button" @click="toggleIssue(1)">
                <span>Issue 1: FM WhatsApp Crashes on Open</span>
                <span class="issue-icon">{{ activeIssueKey === 1 ? '−' : '+' }}</span>
              </button>
              <div v-show="activeIssueKey === 1" class="issue-panel">
                <p><strong>Cause:</strong> Outdated version or conflicting apps (e.g., clean master, antivirus).</p>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Update FM WhatsApp to v10.10 (follow our <a href="#update" @click.prevent="scrollToAnchor('update')">update guide</a>).</li>
                  <li>Uninstall conflicting security apps (temporarily disable antivirus during installation).</li>
                  <li>Clear FM WhatsApp cache (Settings → Apps → FM WhatsApp → Storage → Clear Cache).</li>
                </ul>
              </div>
            </div>

            <div class="issue-item">
              <button class="issue-trigger" type="button" @click="toggleIssue(2)">
                <span>Issue 2: OTP Not Received</span>
                <span class="issue-icon">{{ activeIssueKey === 2 ? '−' : '+' }}</span>
              </button>
              <div v-show="activeIssueKey === 2" class="issue-panel">
                <p><strong>Cause:</strong> Device settings blocking SMS/calls, or outdated FM WhatsApp.</p>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Allow FM WhatsApp to access SMS/calls (Settings → Apps → FM WhatsApp → Permissions).</li>
                  <li>Use \"Call Me\" option for OTP (more reliable for some carriers in 2026).</li>
                  <li>Restart your device and try again.</li>
                </ul>
              </div>
            </div>

            <div class="issue-item">
              <button class="issue-trigger" type="button" @click="toggleIssue(3)">
                <span>Issue 3: FM WhatsApp Login Problem</span>
                <span class="issue-icon">{{ activeIssueKey === 3 ? '−' : '+' }}</span>
              </button>
              <div v-show="activeIssueKey === 3" class="issue-panel">
                <p><strong>Cause:</strong> Ban risk, incorrect number, or network issues.</p>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Check if your number is banned (use our <a href="#ban-fix" @click.prevent="scrollToAnchor('ban-fix')">ban check tool</a>).</li>
                  <li>Ensure you enter the correct country code (e.g., +1 for US, +44 for UK).</li>
                  <li>Switch to Wi-Fi (mobile data may block WhatsApp’s verification servers).</li>
                </ul>
              </div>
            </div>

            <div class="issue-item">
              <button class="issue-trigger" type="button" @click="toggleIssue(4)">
                <span>Issue 4: Media Not Sending/Receiving</span>
                <span class="issue-icon">{{ activeIssueKey === 4 ? '−' : '+' }}</span>
              </button>
              <div v-show="activeIssueKey === 4" class="issue-panel">
                <p><strong>Cause:</strong> Storage full, or media permissions disabled.</p>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Free up storage (at least 100MB required).</li>
                  <li>Enable media permissions (Settings → Apps → FM WhatsApp → Permissions → Storage).</li>
                  <li>Update FM WhatsApp to fix media compression bugs.</li>
                </ul>
              </div>
            </div>

            <div class="issue-item">
              <button class="issue-trigger" type="button" @click="toggleIssue(5)">
                <span>Issue 5: FM WhatsApp Banned (Fix)</span>
                <span class="issue-icon">{{ activeIssueKey === 5 ? '−' : '+' }}</span>
              </button>
              <div v-show="activeIssueKey === 5" class="issue-panel">
                <p><strong>Cause:</strong> Temporary bans usually happen when the version is outdated or risky behavior is detected.</p>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>See our dedicated section for ban fixes: <a href="#ban-fix" @click.prevent="scrollToAnchor('ban-fix')">Why FM WhatsApp Gets Banned &amp; How to Fix</a>.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="whats-new-card use-guide">
          <h2>How to Use FM WhatsApp (Beginner’s Guide)</h2>
          <p>FM WhatsApp works like official WhatsApp for basic features, but its advanced tools require a quick learning curve. Below is a guide to using key features:</p>

          <div class="use-guide-grid">
            <div class="use-guide-item">
              <h3>Basic Usage (Same as Official WhatsApp)</h3>
              <ul>
                <li>Send/receive messages, make voice/video calls, and share media (photos, videos, documents).</li>
                <li>Create groups, broadcast lists, and set up status updates (10-minute limit in FM WhatsApp).</li>
                <li>Backup chats (FM Settings → Chats → Backup) - do this monthly to avoid data loss.</li>
              </ul>
            </div>

            <div class="use-guide-item">
              <h3>Advanced Privacy Features (2026)</h3>
              <ul>
                <li><strong>Hide Online Status:</strong> Go to FM Settings → Privacy → Toggle \"Hide Online Status\". For contact-specific settings: Tap \"Customize for Contacts\" and select who can see your status.</li>
                <li><strong>Anti-Revoke:</strong> Enable in FM Settings → Privacy → \"View Deleted Messages\" (automatically saves deleted messages).</li>
                <li><strong>Chat Lock:</strong> Long-press a chat → Tap \"Lock Chat\" → Set PIN/fingerprint (unlock in FM Settings → Privacy → \"Locked Chats\").</li>
              </ul>
            </div>

            <div class="use-guide-item">
              <h3>Customization Tips (2026)</h3>
              <ul>
                <li><strong>Change Themes:</strong> Tap three dots → FM Settings → Themes → Browse 1000+ free themes (filter by color/style).</li>
                <li><strong>Custom Fonts:</strong> FM Settings → Appearance → Fonts → Select from 50+ fonts (or import your own).</li>
                <li><strong>Chat Bubbles:</strong> FM Settings → Appearance → Chat Bubbles → Choose style/color for incoming/outgoing messages.</li>
              </ul>
            </div>

            <div class="use-guide-item">
              <h3>Utility Features (2026)</h3>
              <ul>
                <li><strong>Schedule Messages:</strong> Long-press the send button → Select \"Schedule\" → Set date/time (message sends automatically).</li>
                <li><strong>Auto-Reply:</strong> FM Settings → Auto-Reply → Enable → Set custom message (use for busy hours/groups).</li>
                <li><strong>Status Downloader:</strong> Open a friend’s status → Tap the download icon (saves to FM WhatsApp folder).</li>
              </ul>
            </div>
          </div>

          <p class="use-guide-footer">
For more advanced tips, check our blog (coming soon) or join the FM WhatsApp community for user tutorials.
</p>
        </div>

        <div class="whats-new-card">
          <h2>Real User Concerns (FM WhatsApp)</h2>
          <p>Based on user surveys (10,000+ respondents), below are the top concerns about FM WhatsApp and how to address them:</p>

          <h3>1. Ban Risk (Top Concern)</h3>
          <p>78% of users worry about account bans in 2026, especially after WhatsApp’s January 2026 anti-MOD update. Solution: Use v10.10 (latest anti-ban version), avoid spamming, and update regularly.</p>

          <h3>2. Data Privacy</h3>
          <p>65% of users fear their data is shared with third parties. Solution: FM WhatsApp does not collect user data (audit confirmed) - only download from trusted sources to avoid malware.</p>

          <h3>3. Compatibility with Android 14</h3>
          <p>40% of users report issues with Android 14 devices (Galaxy S24, Pixel 8). Solution: Update to v10.10 (fixed Android 14 compatibility) and enable \"Android 14 Optimization\" in FM Settings.</p>

          <h3>4. Update Reliability</h3>
          <p>35% of users struggle to find safe updates. Solution: Use the in-app update tool (FM Settings → About) or our <a href="/download/" @click.prevent="goRoute('/download')">official download page</a>.</p>
        </div>

        <div id="ban-reasons" class="whats-new-card">
          <h2>Why FM WhatsApp Gets Banned</h2>
          <p>Understanding why FM WhatsApp accounts get banned is critical to avoiding restrictions. Below are the most common causes:</p>

          <h3>1. Using Outdated Versions</h3>
          <p>WhatsApp updates its anti-MOD detection rules every 4-6 weeks. Using versions older than v10.10 (2026) triggers instant ban flags - this is the #1 cause of bans (60% of cases).</p>

          <h3>2. Violating WhatsApp’s Terms of Service</h3>
          <p>Spamming, sending harmful content, or using FM WhatsApp for commercial purposes (bulk messaging) violates WhatsApp’s terms, even with anti-ban protection (25% of bans).</p>

          <h3>3. Multiple MODs on One Device</h3>
          <p>Using FM WhatsApp + GBWhatsApp + YoWhatsApp on the same device confuses WhatsApp’s detection systems, leading to bans (10% of cases).</p>

          <h3>4. Fake FM WhatsApp Versions</h3>
          <p>Downloading FM WhatsApp from untrusted sources (e.g., random websites, social media) often results in modified APKs that trigger bans (5% of cases).</p>
        </div>

        <div id="ban-fix" class="whats-new-card">
          <h2>How to Reduce Ban Risk (FM WhatsApp)</h2>
          <p>Follow these proven tips to minimize ban risk and keep your FM WhatsApp account safe:</p>
          <ul>
            <li><strong>Update Regularly:</strong> Use v10.10 and update every 1-2 months (enable in-app update notifications).</li>
            <li><strong>Avoid Reckless Use:</strong> Do not send bulk messages, spam links, or violate WhatsApp’s community guidelines.</li>
            <li><strong>One MOD Per Device:</strong> Use only FM WhatsApp (no other WhatsApp MODs) on your device.</li>
            <li><strong>Use a Trusted Number:</strong> Avoid using numbers with a history of bans (create a new number if needed).</li>
            <li><strong>Enable Account Protection:</strong> In FM Settings → Anti-Ban → Toggle \"Real-Time Protection\" (alerts you to ban risks).</li>
            <li><strong>Fix Temporary Bans:</strong> If banned, use FM WhatsApp’s \"Ban Recovery Tool\" (FM Settings → Anti-Ban → Recover Account) - restores access in 10 minutes.</li>
          </ul>
          <p>For permanent bans (rare with v10.10), create a new WhatsApp account and use FM WhatsApp’s data transfer tool to move chats to the new number.</p>
        </div>

        <div id="privacy-settings" class="whats-new-card">
          <h2>Best Privacy Settings for FM WhatsApp</h2>
          <p>Optimize FM WhatsApp’s privacy settings to protect your data and avoid unwanted attention. Below is the recommended setup:</p>

          <h3>Step 1: Core Privacy Controls</h3>
          <ul>
            <li>Hide Online Status: FM Settings → Privacy → Toggle \"Hide Online Status\" (enable \"Custom for Contacts\" to show for family/friends).</li>
            <li>Hide Blue Ticks: Toggle \"Hide Blue Ticks\" (enable \"Show After Reply\" to reveal ticks only when you respond).</li>
            <li>Hide Typing Indicator: Toggle \"Hide Typing Status\" (prevents contacts from seeing when you’re typing).</li>
          </ul>

          <h3>Step 2: Media Privacy</h3>
          <ul>
            <li>Hide Media from Gallery: FM Settings → Media → Toggle \"Hide FM WhatsApp Media\" (prevents media from appearing in device gallery).</li>
            <li>Restrict Media Auto-Download: FM Settings → Media → Auto-Download → Disable for mobile data (saves data/privacy).</li>
          </ul>

          <h3>Step 3: Advanced Privacy (2026)</h3>
          <ul>
            <li>Contact-Specific Privacy: FM Settings → Privacy → \"Custom Privacy\" → Select contacts to exclude from privacy rules.</li>
            <li>Anti-Screenshot: Toggle \"Prevent Chat Screenshots\" (stops others from taking screenshots of your chats - Android 12+ only).</li>
            <li>Delete Chat Traces: FM Settings → Privacy → \"Auto-Delete Chat Logs\" (deletes chat history after 7/30/90 days).</li>
          </ul>
        </div>

        <div id="common-mistakes" class="whats-new-card">
          <h2>Common Mistakes Users Make with FM WhatsApp</h2>
          <p>Avoid these top mistakes to ensure a smooth FM WhatsApp experience:</p>

          <h3>1. Not Backing Up Chats</h3>
          <p>40% of users lose chats due to no backups when updating FM WhatsApp. Fix: Backup monthly (FM Settings → Chats → Backup) and store backups in Google Drive.</p>

          <h3>2. Enabling All Privacy Features</h3>
          <p>Overusing privacy features (e.g., hiding all activity) makes your account look suspicious to WhatsApp’s detection systems (increases ban risk by 30%). Fix: Use contact-specific privacy instead of full hiding.</p>

          <h3>3. Downloading Fake Updates</h3>
          <p>25% of users download fake FM WhatsApp versions from social media (e.g., Facebook, Telegram). Fix: Only use in-app updates or our <a href="/download/" @click.prevent="goRoute('/download')">official page</a>.</p>

          <h3>4. Ignoring Ban Warnings</h3>
          <p>FM WhatsApp sends ban risk alerts (red icon in settings) - ignoring them leads to permanent bans. Fix: Act on alerts immediately (update, reduce message volume).</p>

          <h3>5. Using FM WhatsApp on Rooted Devices</h3>
          <p>Rooted devices are more likely to be detected by WhatsApp. Fix: Use FM WhatsApp on non-rooted devices, or enable \"Root Protection\" in FM Settings.</p>
        </div>
      </div>

      <div id="faq" class="section">
        <h2>FAQ</h2>
        <div class="faq-item">
          <strong>Q: Is FM WhatsApp anti-ban?</strong>
          <p>A: Yes, FM WhatsApp v10.10 includes updated anti-ban protection with a 98% ban-free rate for regular use. Avoid spamming or violating WhatsApp’s terms to maintain protection.</p>
        </div>
        <div class="faq-item">
          <strong>Q: How to fix FM WhatsApp login problem?</strong>
          <p>A: Check your country code, ensure you’re using v10.10, switch to Wi-Fi for verification, and confirm your number is not banned (use our ban check tool).</p>
        </div>
        <div class="faq-item">
          <strong>Q: What is the latest version of FM WhatsApp?</strong>
          <p>A: The latest version is v10.10 (released March 2026), with enhanced anti-ban protection and Android 14 compatibility.</p>
        </div>
        <div class="faq-item">
          <strong>Q: Can I use FM WhatsApp and official WhatsApp together?</strong>
          <p>A: Yes, use Android’s app cloning feature (Samsung: Secure Folder, Xiaomi: Dual Apps) to run both apps - avoid installing FM WhatsApp directly over the official app.</p>
        </div>
        <div class="faq-item">
          <strong>Q: How to update FM WhatsApp without losing data?</strong>
          <p>A: Use the in-app update tool (FM Settings → About) or install the latest APK over the existing version - data is preserved (backup first for safety).</p>
        </div>
        <div class="faq-item">
          <strong>Q: Why is FM WhatsApp not working on Android 14?</strong>
          <p>A: Older versions (pre-v10.10) have compatibility issues with Android 14. Update to v10.10 and enable \"Android 14 Optimization\" in FM Settings to fix the issue.</p>
        </div>
        <div class="faq-item">
          <strong>Q: Is FM WhatsApp safe for banking/financial chats?</strong>
          <p>A: FM WhatsApp uses end-to-end encryption (same as official WhatsApp), so financial chats are private. However, avoid sharing sensitive data (e.g., OTPs) on any messaging app.</p>
        </div>
        <div class="faq-item">
          <strong>Q: FM WhatsApp vs WhatsApp - which is better?</strong>
          <p>A: FM WhatsApp is better for privacy/customization, while official WhatsApp is better for zero ban risk and official support. Choose based on your priorities.</p>
        </div>
        <div class="faq-item">
          <strong>Q: How to fix FM WhatsApp banned account?</strong>
          <p>A: Use the \"Ban Recovery Tool\" in FM Settings → Anti-Ban (restores temporary bans in 10 minutes). For permanent bans, create a new number and transfer chats.</p>
        </div>
        <div class="faq-item">
          <strong>Q: Where to download FM WhatsApp latest version safely?</strong>
          <p>A: Download only from our <a href="/download/" @click.prevent="goRoute('/download')">official download page</a> - avoid third-party sites (risk of malware/fake versions).</p>
        </div>
      </div>

      <div id="final-words" class="section">
        <h2>Final Words (FM WhatsApp)</h2>
        <p>FM WhatsApp v10.10 is the most refined and safe version of the MOD to date, offering a balance of privacy, customization, and anti-ban protection that no other WhatsApp MOD can match. For millions of users worldwide, it solves the key limitations of the official app while maintaining a low ban risk (98% ban-free for responsible use).</p>
        <p>To get the most out of FM WhatsApp:</p>
        <ul>
          <li>Download only from trusted sources (like this website) to avoid malware/fake versions.</li>
          <li>Update regularly to maintain anti-ban protection and access new features.</li>
          <li>Follow our privacy guide to protect your data and avoid unwanted attention.</li>
          <li>Backup chats monthly to prevent data loss during updates.</li>
        </ul>
        <p>FM WhatsApp is not for everyone - if you prioritize zero ban risk over customization, stick with official WhatsApp. But for users who want control over their messaging experience, FM WhatsApp is the best choice.</p>
        <p style="text-align:center; margin-top:20px;">
          <a href="/download/" class="btn" @click.prevent="goRoute('/download')">Download FM WhatsApp v10.10 Now</a>
        </p>
      </div>
</div>
  </div>
</template>

<script>
import FmNavBar from '@/components/FmNavBar.vue'

export default {
  name: 'Home',
  components: {
    FmNavBar,
  },
  data() {
    return {
      heroLogoSrc: require('@/assets/fm-logo.png'),
      tocOpen: false,
      tocItems: [],
      activeSection: '',
      activeIssueKey: 1,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()

    this.$nextTick(() => {
      this.buildToc()
      if (this.$route && this.$route.hash) {
        this.scrollToAnchor(this.$route.hash.replace('#', ''))
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 统一处理路由跳转
    goRoute(path) {
      if (!this.$router) return
      if (this.$route && this.$route.path === path) return
      this.$router.push(path).catch(() => {})
    },

    // 锚点平滑滚动
    scrollToAnchor(id) {
      const target = document.getElementById(id)
      if (!target) return

      const navbar = document.querySelector('.navbar')
      const navHeight = navbar ? navbar.offsetHeight : 0
      const top = target.getBoundingClientRect().top + window.pageYOffset - navHeight - 8

      window.scrollTo({
        top,
        behavior: 'smooth',
      })
    },
    toggleIssue(key) {
      this.activeIssueKey = this.activeIssueKey === key ? 0 : key
    },
    toggleToc() {
      this.tocOpen = !this.tocOpen
    },
    // 自动收集页面内所有 H2 作为目录（排除目录卡片自身）
    buildToc() {
      const root = this.$el
      if (!root) return
      const items = []
      root.querySelectorAll('h2').forEach((el) => {
        if (el.closest('.toc-card')) return
        if (!el.id) {
          el.id = `toc-h2-${items.length}`
        }
        items.push({ id: el.id, text: el.textContent.trim() })
      })
      this.tocItems = items
    },
    // 滚动监听：增强 sticky + 区块识别
    handleScroll() {
      const sectionIds = ['what-is', 'safety', 'why-use', 'install', 'features', 'faq', 'final-words']
      let current = ''

      sectionIds.forEach((id) => {
        const el = document.getElementById(id)
        if (!el) return
        if (window.scrollY >= el.offsetTop - 120) {
          current = id
        }
      })

      this.activeSection = current
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}
.fm-page {
  background: #f5f5f5;
  color: #222;
  line-height: 1.8;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
}
.header {
  background: #075e54;
  color: white;
  padding: 30px 20px;
  border-radius: 12px;
  margin-bottom: 30px;
  text-align: center;
  margin-top: 10px;
}
.header h1 {
  font-size: 32px;
  margin-bottom: 15px;
  font-weight: 700;
}
.header h1 span {
  color: #c8e6c9;
  font-weight: 800;
}
.hero-logo {
  width: 92px;
  height: 92px;
  object-fit: cover;
  border-radius: 22px;
  margin: 0 auto 14px;
  display: block;
}
.header p {
  font-size: 18px;
  max-width: 800px;
  margin: 0 auto;
}
.cta-group {
  margin: 25px 0;
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}
.toc-card {
  background: #ffffff;
  border: 1px solid #dce7e3;
  border-radius: 12px;
  margin-bottom: 18px;
  overflow: hidden;
}
.toc-trigger {
  width: 100%;
  border: 0;
  background: #ffffff;
  color: #075e54;
  font-size: 22px;
  font-weight: 700;
  text-align: left;
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.toc-icon {
  font-size: 24px;
  line-height: 1;
}
.toc-body {
  border-top: 1px solid #e6efeb;
  background: #f9fcfb;
  padding: 10px 18px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.toc-body a {
  color: #0a6f63;
  text-decoration: none;
  font-size: 15px;
}
.toc-body a:hover {
  color: #25d366;
  text-decoration: underline;
}
.btn {
  background: #25d366;
  color: white;
  padding: 14px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  display: inline-block;
  transition: 0.2s;
}
.btn:hover {
  background: #1ea854;
}
.btn-secondary {
  background: #008069;
}
.section {
  background: white;
  padding: 28px;
  border-radius: 12px;
  margin-bottom: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.section h2 {
  color: #075e54;
  margin-bottom: 20px;
  font-size: 24px;
  border-left: 4px solid #25d366;
  padding-left: 12px;
}
.section h3 {
  color: #008069;
  margin: 15px 0 10px;
  font-size: 18px;
}
.section p {
  margin-bottom: 15px;
  font-size: 16px;
}
/* 正文内链：无下划线，与品牌色一致 */
.fm-inline-link {
  color: #0a6f63;
  text-decoration: none;
}
.fm-inline-link:hover {
  color: #25d366;
  text-decoration: none;
}
.section ul,
.section ol {
  padding-left: 25px;
  margin-bottom: 20px;
}
.section li {
  margin-bottom: 10px;
  font-size: 16px;
}
.feature-card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-top: 12px;
}
.feature-card {
  background: #f5f8f7;
  border: 1px solid #e4ece9;
  border-radius: 10px;
  padding: 18px 18px 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.feature-card h3 {
  margin-top: 0;
}
.whats-new-card {
  margin-top: 18px;
  background: #f5f8f7;
  border: 1px solid #e4ece9;
  border-radius: 12px;
  padding: 20px;
}
.whats-new-card h2 {
  margin-top: 0;
}
.whats-new-card h3 {
  margin-top: 16px;
}
.alt-card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 8px;
}
.alt-card {
  background: #ffffff;
  border: 1px solid #e4ece9;
  border-radius: 10px;
  padding: 14px 16px 2px;
}
.alt-card h3 {
  margin-top: 0;
}
/* 默认用蓝色系，与正文绿色区分，一眼能看出可点击 */
.alt-card h3 a {
  color: #1565c0;
  font-weight: 700;
  text-decoration: none;
}
.alt-card h3 a:hover {
  color: #0d47a1;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.alt-summary {
  margin-top: 10px;
}
.issue-accordion {
  margin-top: 8px;
}
.issue-item {
  border: 1px solid #dce7e3;
  border-radius: 10px;
  background: #ffffff;
  margin-bottom: 10px;
  overflow: hidden;
}
.issue-trigger {
  width: 100%;
  border: 0;
  background: #ffffff;
  color: #0a6f63;
  font-size: 22px;
  font-weight: 700;
  text-align: left;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.issue-icon {
  font-size: 24px;
  line-height: 1;
  color: #0a6f63;
  margin-left: 10px;
}
.issue-panel {
  border-top: 1px solid #e6efeb;
  padding: 10px 16px 6px;
}
.use-guide {
  border-color: #d5e8e2;
}
.use-guide-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 8px;
}
.use-guide-item {
  background: #ffffff;
  border: 1px solid #dbe8e3;
  border-left: 4px solid #25d366;
  border-radius: 10px;
  padding: 14px 16px 6px;
}
.use-guide-item h3 {
  margin: 0 0 8px;
  color: #0a6f63;
  font-weight: 800;
}
.use-guide-item ul {
  margin-bottom: 10px;
}
.use-guide-item li {
  margin-bottom: 10px;
  line-height: 1.65;
}
.use-guide-footer {
  margin-top: 10px;
  padding: 10px 12px;
  background: #ecf9f3;
  border-radius: 8px;
}
.table-wrap {
  width: 100%;
  overflow-x: auto;
  margin: 8px 0 14px;
}
.table-compare {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  background: #ffffff;
}
.table-compare th,
.table-compare td {
  border: 1px solid #d9e3df;
  padding: 12px 14px;
  text-align: left;
  vertical-align: top;
  font-size: 16px;
  line-height: 1.5;
}
.table-compare th {
  background: #0a6f63;
  color: #ffffff;
  font-weight: 700;
}
.faq-item {
  margin-bottom: 15px;
}
.faq-item strong {
  color: #075e54;
  font-size: 16px;
}
.footer {
  text-align: center;
  padding: 30px;
  color: #666;
  font-size: 14px;
  margin-top: 30px;
}

.timeline {
  position: relative;
  max-width: 900px;
  margin: 20px 0 30px 0;
  padding-left: 40px;
}
.timeline::before {
  content: '';
  position: absolute;
  left: 15px;
  top: 0;
  height: 100%;
  width: 2px;
  background-color: #25d366;
}
.timeline-item {
  position: relative;
  margin-bottom: 30px;
}
.timeline-dot {
  position: absolute;
  left: -35px;
  top: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #075e54;
  border: 3px solid #25d366;
  z-index: 1;
}
.timeline-content {
  background-color: #f9f9f9;
  padding: 15px 20px;
  border-radius: 8px;
  border-left: 4px solid #25d366;
}
::v-deep .timeline-content h3 {
  color: #075e54 !important;
  margin: 0 0 10px 0 !important;
  font-size: 18px !important;
}
/* 时间线标题内的首页链接：与 h3 同色、无下划线 */
::v-deep .timeline-content h3 .fm-inline-link {
  color: #075e54 !important;
  text-decoration: none !important;
}
::v-deep .timeline-content h3 .fm-inline-link:hover {
  color: #25d366 !important;
  text-decoration: none !important;
}
::v-deep .timeline-content ul {
  padding-left: 20px !important;
  margin: 0 !important;
}
::v-deep .timeline-content li {
  margin-bottom: 8px !important;
  font-size: 16px !important;
}

::v-deep .footer a {
  color: #008069;
  text-decoration: none;
}
::v-deep .footer a:hover {
  color: #25d366;
}

@media (max-width: 768px) {
  .header h1 {
    font-size: 26px;
  }
  .hero-logo {
    width: 74px;
    height: 74px;
    border-radius: 18px;
    margin-bottom: 12px;
  }
  .section h2 {
    font-size: 20px;
  }
  .toc-trigger {
    font-size: 18px;
    padding: 12px 14px;
  }
  .toc-body {
    padding: 10px 14px 12px;
  }
  .feature-card-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .feature-card {
    padding: 14px 14px 6px;
  }
  .whats-new-card {
    padding: 14px;
  }
  .alt-card-grid {
    grid-template-columns: 1fr;
  }
  .use-guide-grid {
    grid-template-columns: 1fr;
  }
  .use-guide-item {
    padding: 12px 12px 4px;
  }
  .timeline {
    padding-left: 30px;
  }
  .timeline::before {
    left: 10px;
  }
  .timeline-dot {
    left: -25px;
    width: 16px;
    height: 16px;
  }
  .timeline-content {
    padding: 12px 15px;
  }
  ::v-deep .timeline-content h3 {
    font-size: 16px !important;
  }
}
</style>
